import { Component, OnInit, ViewChild } from '@angular/core';

import { Client } from '../../shared/client.model';

import {
  AlertController,
  LoadingController,
  ModalController,
  NavController,
  ToastController
} from '@ionic/angular';
import { Product } from '../../shared/product.model';
import { Router } from '@angular/router';
import { AuthService } from '../../service/auth.service';
import { OrderResponse } from '../../shared/orderResponse.model';
import { OrderDetailResponse } from '../../shared/orderDetailResponse.model';
import { Order } from '../../shared/order.model';
import { BnplService } from 'src/app/service/bnpl.service';
import { Fua } from 'src/app/shared/fua.model';
import { DetailBnpl } from 'src/app/shared/detailBnpl.model';
import { Constant } from "../../shared/model/Constant";
import { OverlayEventDetail } from '@ionic/core/components';
import { OrderService } from 'src/app/service/order.service';

@Component({
  selector: 'app-order',
  templateUrl: './order.page.html',
  styleUrls: ['./order.page.scss'],
})
export class OrderPage implements OnInit {

  orders: Order[];
  ordersFiltered: Order[];
  client: Client;
  product: Product;
  order: OrderResponse;
  orderBnpl: OrderResponse;
  orderDetailBnpl: DetailBnpl;
  orderDetails: OrderDetailResponse[];
  orderId: string;
  subtotalAmountProduct: number = 0;
  totalAmountProduct: number = 0;
  totalDiscount: number = 0;
  discount: number = 0;
  showConfirm: boolean;
  showMethod: boolean;
  showEndTrx: boolean = false;
  showModalBnplInfo: boolean = false;
  title: string = "";
  titleEnd: string = "Tu pago esta siendo procesado.";
  imgEnd: string = "endBnpl";
  messageEnd: string = "Te avisaremos en las próximas horas por correo electrónico cuando el pago se haya completado.";
  message: string;
  detailMessage: string;
  bnplTransactionId: string;
  balance: number;
  ipClient: string = "181.59.2.216";


  constructor(public modalController: ModalController,
    public alertController: AlertController,
    public toastController: ToastController,
    private nav: NavController,
    private authService: AuthService,
    private orderService: OrderService,
    private bnplService: BnplService,
    public loadingController: LoadingController, private router: Router) {


    var orderStorage = localStorage.getItem(Constant.bnpl);

    var orderDetailStorage = localStorage.getItem(Constant.detailBnpl);

    if (orderDetailStorage != "undefined" && orderDetailStorage != null) {
      this.orderDetailBnpl = JSON.parse(orderDetailStorage);
    }

    if (orderStorage != "undefined" && orderStorage != null) {
      this.orderBnpl = JSON.parse(orderStorage);
    }
    var urlTree = this.router.parseUrl(this.router.url);
    this.orderId = urlTree.queryParams['id'];
    localStorage.removeItem(Constant.bnpl);
    localStorage.removeItem(Constant.detailBnpl);
  }

  addDescount() {
  }

  openModalDescrptProduct() {
    this.showMethod = false;
    this.showConfirm = true;
  }

  openModalMethod() {
    this.showMethod = false;
    this.showMethod = true;
  }

  async presentToast(txt) {
    const toast = await this.toastController.create({
      message: txt,
      duration: 2500,
      position: 'top',
      mode: 'ios',
      color: 'primary'
    });
    toast.present();
  }

  ngOnInit() {

    this.bnplService.getIp().subscribe((res: any) => {
      this.ipClient = res.IPv4;
    }, error => {
      console.warn('Error fua no ip 1', error);
      this.bnplService.getIp1().subscribe((res: any) => {
        console.log(res);
        this.ipClient = res.ip;
      }, error => {
        console.warn('Error fua no ip 2', error);
      });
    });

    this.getToken();


    console.log("getOrdersById");
    console.log(this.orderId);

    this.orderService.getOrdersById(this.orderId).subscribe((res: OrderResponse) => {
      this.order = res;
      if (this.order && this.order.idstatusorder === 1 || this.order.idstatusorder === 6 || this.order.idstatusorder === 2 || this.order.idstatusorder === 7) {
        this.orderDetails = this.order.orderDetail;
        this.totalAmountProduct = 0;
        this.subtotalAmountProduct = 0;
        this.order.orderDetail.forEach(detail => {
          this.subtotalAmountProduct = this.subtotalAmountProduct + (detail.quantity * detail.value);
          this.totalDiscount = this.totalDiscount + (detail.discount);
        });
        this.totalAmountProduct = this.subtotalAmountProduct - this.totalDiscount;

        console.log(this.order.idstatusorder);
        switch (this.order.idstatusorder) {
          case 1: { //Creada
            if (this.orderBnpl && this.orderBnpl.codeBnpl) {
              if (this.orderBnpl.typeFua === Constant.typeFuaPN) {

                var requestSession = {
                  "authCode": this.orderBnpl.codeBnpl,
                  "idOrden": this.orderBnpl.idOrder,
                  "ip": this.ipClient,
                  "idClient": this.orderBnpl.idUser
                };
                this.bnplService.sendTrxSessionBnpl(requestSession).subscribe((res: any) => {
                  if (res.errors && res.errors === Constant.expiredCode) {
                    //abrimos componente modal
                    this.showModalBnplInfo = true;
                    this.message = Constant.expiredCodeMessage;
                    return;
                  }
                  this.bnplTransactionId = res.bnplTransactionId;
                  var requestRetrieveQuota = {
                    "bnplTransactionId": this.bnplTransactionId,
                    "idOrden": this.orderBnpl.idOrder,
                    "ip": this.ipClient,
                    "idClient": this.orderBnpl.idUser,
                    "totalPrice": this.totalAmountProduct,
                  };
                  this.bnplService.sendTrxRetrieveQuotaBnpl(requestRetrieveQuota).subscribe((res: any) => {
                    //Validaciones de posibles errores entregados por el servicio
                    console.log(res);
                    if (res.errors) {
                      switch (res.errors.code) {
                        case Constant.expiredCode:
                          this.message = Constant.expiredCodeMessage;
                          break;
                        case Constant.noQuota:
                          this.message = Constant.noQuotaMessage;
                          break;
                        case Constant.updateQuota:
                          this.message = Constant.updateQuotaMessage;
                          break;
                        case Constant.trxNotExist:
                          this.message = Constant.trxNotExistMessage;
                          break;
                        case Constant.commerceNotFound:
                          this.message = Constant.commerceNotFoundMessage;
                          break;
                        case Constant.sessionExpired:
                          this.message = Constant.sessionExpiredMessage;
                          break;
                        default:
                          this.message = Constant.sessionExpiredMessage;
                          break;
                      }
                      this.showModalBnplInfo = true;
                      return;
                    }

                    //Validacion para algunos errores que no traen codigo de error deesde el cliente
                    // if (res.data.info) {
                    //   this.message = res.data.info.message;
                    //   this.showModalBnplInfo = true;
                    //   return;
                    // }

                    console.log(res.balance);
                    if (Number(res.balance) < Number(this.totalAmountProduct)) {
                      this.message = Constant.validateQuotaMessage;
                      this.detailMessage = "Tienes un monto disponible de $" + res.balance
                      this.showModalBnplInfo = true;
                      return;
                    }
                    this.balance = res.balance;
                    console.log(this.balance);
                    localStorage.removeItem(Constant.detailBnpl);
                    var detailBnpl = new DetailBnpl();
                    detailBnpl.bnplTransactionId = this.bnplTransactionId;
                    detailBnpl.accounts = res.accounts;
                    this.order.totalAmount = this.totalAmountProduct;
                    detailBnpl.balance = this.balance;
                    detailBnpl.commission = res.commission;
                    detailBnpl.order = this.order;
                    console.log(detailBnpl);
                    localStorage.setItem(Constant.detailBnpl, JSON.stringify(detailBnpl));
                    this.router.navigate(['/detailOrder']);

                  }, error => {
                    this.showModalBnplInfo = true;
                    this.message = "La consulta de saldo no fue exitosa.";
                  });

                }, error => {
                  this.showModalBnplInfo = true;
                  this.message = "El código de autorización no es valido.";
                });
              } else if (this.orderBnpl.typeFua === Constant.typeFuaCD) {
                var requestOrigination = {
                  "authCode": this.orderBnpl.codeBnpl,
                  "bnplTransactionId": this.orderDetailBnpl.bnplTransactionId,
                  "idOrden": this.orderBnpl.idOrder,
                  "ip": this.ipClient,
                  "idClient": this.orderBnpl.idUser
                };
                this.bnplService.sendTrxOriginationBnpl(requestOrigination).subscribe((res: any) => {
                  if (res) {
                    this.showEndTrx = true;
                    setTimeout(this.refresh, 10000, this.orderBnpl, this.orderDetailBnpl);
                  }
                }, error => {
                  console.warn('Error originationOrder ', error);
                  this.presentToast('El proveedor no responde, intente mas tarde por favor.');
                });
              }

            }

            this.showConfirm = false;
            this.ordersFiltered = this.orders;
            break;
          }
          case 2: { //rechazada
            this.titleEnd = "¡Compra Rechazada!";
            this.messageEnd = "No se aprobó el desembolso del préstamo.";
            this.imgEnd = "endBnplError";
            this.showEndTrx = true;
            break;
          }
          case 6: { //Exitosa
            this.titleEnd = "¡Compra Exitosa!";
            var codigoObligacion = this.orderBnpl === undefined ? this.order.idOrder : this.orderBnpl.codeBnpl;
            this.messageEnd = "Código de obligación No. " + codigoObligacion;
            this.showEndTrx = true;
            break;
          }
          case 7: {
            this.titleEnd = "Tu pago esta siendo procesado.";
            var codigoObligacion = this.orderBnpl === undefined ? this.order.idOrder : this.orderBnpl.codeBnpl;
            this.messageEnd = "Te avisaremos en las próximas horas por correo electrónico cuando el pago se haya completado.";
            this.showEndTrx = true;
            setTimeout(() => {
              window.location.reload();
            }, 10000);
          }
          default: {
            if (this.orderBnpl !== undefined && this.orderBnpl.refresh) {
              setTimeout(this.refresh, 10000, this.orderBnpl, this.orderDetailBnpl, this.router);
            }
            break;
          }
        }
      } else {
        this.presentToast('La orden de compra no fue encontrada en el sistema.');
      }

    }, error => {
      console.warn('Error consulta ordenes ', error);
      this.presentToast('No se encuentra ordenes para este comercio.');
    });


  }


  serachOrders(event) {
    const text = event.target.value;
    this.ordersFiltered = this.orders;
    if (text) {
      this.ordersFiltered = this.orders.filter((order: Order) => {
        return (order.idOrder.indexOf(text) > -1);
      });
    }
  }



  async sendFuaBnpl() {
    const loading = await this.loadingController.create({
      message: 'Redireccionando a Bancolombia..',
      spinner: 'bubbles',
      duration: 100000
    });
    await loading.present();
    this.order.typeFua = Constant.typeFuaPN;
    localStorage.setItem(Constant.bnpl, JSON.stringify(this.order));

    var requestFua = {
      "authenticationMode": Constant.typeFuaPN,
      "idOrden": this.order.idOrder,
      "ip": this.ipClient,
      "idClient": this.order.idUser

    };
    this.bnplService.sendTrxFuaBnpl(requestFua).subscribe((res: Fua) => {
      if (res.url === null) {
        this.presentToast('El proveedor no responde, intente mas tarde por favor.');
        loading.dismiss();
        return;
      }
      window.location.href = res.url;
      loading.dismiss();
    }, error => {
      console.warn('Error fua autenticacion ', error);
      this.presentToast('No se encuentra el proveedor disponible.');
      loading.dismiss();
    });
  }

  close() {
    this.showConfirm = false;
    this.showMethod = false;
    this.showEndTrx = false;
  }


  onWillDismissEndTrx(modalEvent: Event) {
    if (modalEvent.type === 'willDismiss') {
      this.showEndTrx = false;
    }
  }

  onWillDismissConfirm(modalEvent: Event) {
    if (modalEvent.type === 'willDismiss') {
      this.showConfirm = false;
    }
  }

  onWillDismissMethod(event: Event) {
    if (event.type === 'willDismiss') {
      this.showMethod = false;
    }
  }

  refresh(orderBnpl: OrderResponse, orderDetailBnpl: DetailBnpl, router: Router) {
    orderBnpl.refresh = true;
    localStorage.setItem(Constant.bnpl, JSON.stringify(orderBnpl));
    localStorage.setItem(Constant.detailBnpl, JSON.stringify(orderDetailBnpl));
    window.location.reload();
  }

  getToken() {
    let data = {
      document: 60005,
      password: 'Dejando22*'
    };
    this.authService.login(data).subscribe((res: any) => {
      localStorage.setItem(Constant.token, res.token);
    }, error => {
      // console.log("No funciono");
    });
  }

}
